var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FavoritesGroup"},[_c('FavoritesDefault',_vm._g(_vm._b({},'FavoritesDefault',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('FavoritesCollectSuccess',_vm._g(_vm._b({},'FavoritesCollectSuccess',_vm.$attrs,false),_vm.$listeners)),_vm._v(" "),_c('FavoritesCompany')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }